/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceBulkActionLeadResult } from './InstanceBulkActionLeadResult';
import {
    InstanceBulkActionLeadResultFromJSON,
    InstanceBulkActionLeadResultFromJSONTyped,
    InstanceBulkActionLeadResultToJSON,
    InstanceBulkActionLeadResultToJSONTyped,
} from './InstanceBulkActionLeadResult';

/**
 * 
 * @export
 * @interface InstanceBulkActionResult
 */
export interface InstanceBulkActionResult {
    /**
     * 
     */
    results: Array<InstanceBulkActionLeadResult>;
}

/**
 * Check if a given object implements the InstanceBulkActionResult interface.
 */
export function instanceOfInstanceBulkActionResult(value: object): value is InstanceBulkActionResult {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function InstanceBulkActionResultFromJSON(json: any): InstanceBulkActionResult {
    return InstanceBulkActionResultFromJSONTyped(json, false);
}

export function InstanceBulkActionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(InstanceBulkActionLeadResultFromJSON)),
    };
}

export function InstanceBulkActionResultToJSON(json: any): InstanceBulkActionResult {
    return InstanceBulkActionResultToJSONTyped(json, false);
}

export function InstanceBulkActionResultToJSONTyped(value?: InstanceBulkActionResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': ((value['results'] as Array<any>).map(InstanceBulkActionLeadResultToJSON)),
    };
}

